module.exports = __webpack_public_path__ + "static/media/Daily_Electric_Spank2.0db1a082.mp3";